
export default function DifferentiatorSection() {
  return (
    <section id="about" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/000745ea5477ac1971ad11ea6f2dc4d7/7e64a84fef9c0c4e678b9a8781957d90.jpeg"
              alt="Professional legal consultation"
              className="w-full h-96 object-cover object-top rounded-lg shadow-sm"
            />
          </div>
          
          <div>
            <div className="mb-8">
              <h2 className="text-4xl font-light text-stone-900 mb-4">
                Your Trusted Legal Partner
              </h2>
            </div>
            
            <p className="text-lg text-stone-600 mb-12 leading-relaxed font-light">
              With years of experience in legal practice, I provide comprehensive legal services 
              tailored to meet your specific needs with professionalism and dedication.
            </p>
            
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-stone-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-stone-900 mb-2">&nbsp;Our Approach</h4>
                  <p className="text-stone-600 font-light">
                    Assessment: Understand the client&apos;s objectives and operational context.<br />&nbsp;&nbsp;&nbsp;&nbsp;
                    Analysis: Conduct legal, regulatory, and institutional mapping.<br />&nbsp;&nbsp;&nbsp;&nbsp;
                    Strategy: Develop tailored recommendations for efficient engagement and risk mitigation.<br />&nbsp;&nbsp;&nbsp;&nbsp;
                    Implementation Support: Guide organizations on navigating processes and achieving objectives.<br />&nbsp;&nbsp;&nbsp;&nbsp;
                    Capacity Building: Strengthen internal expertise through workshops and training programs.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-stone-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-stone-900 mb-2">Proven Results</h4>
                  <p className="text-stone-600 font-light">Track record of successful outcomes and satisfied clients across various legal matters.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-stone-400 rounded-full mt-3"></div>
                <div>
                  <h4 className="font-medium text-stone-900 mb-2">Clear Communication</h4>
                  <p className="text-stone-600 font-light">Transparent legal advice and regular updates throughout your case.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
